import { generateQueryKey } from '../../apis-infra';
import { getSharedQueryClient } from './queryClientInstance';
import { getQueryFilter } from './queryFilters';
export function toCachedQuery() {
  var _query$meta;
  const query = arguments.length === 1 ? arguments.length <= 0 ? undefined : arguments[0] : arguments.length <= 1 ? undefined : arguments[1];
  const {
    request,
    groupId,
    serviceName,
    methodName,
    tags,
    ...meta
  } = (_query$meta = query.meta) != null ? _query$meta : {};
  return {
    queryKey: query.queryKey,
    meta,
    serviceName,
    methodName,
    error: query.state.error,
    response: query.state.data,
    request,
    groupId,
    tags,
    query
  };
}
export const getCachedValue = (methodConfig, request) => {
  const queryClient = getSharedQueryClient();
  const queryKey = generateQueryKey(methodConfig, request);
  const match = queryClient.getQueryCache().find(queryKey, {
    exact: true
  });
  if (!match) {
    return undefined;
  }
  return toCachedQuery(methodConfig, match);
};
export function findInCache() {
  if (arguments.length === 1) {
    const queryClient = getSharedQueryClient();
    const queryFilter = getQueryFilter(arguments.length <= 0 ? undefined : arguments[0]);
    const matches = queryClient.getQueryCache().findAll({
      predicate: queryFilter
    });
    return matches.map(query => toCachedQuery(query));
  } else {
    return _findInCacheWithMethod(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
  }
}
function _findInCacheWithMethod(methodConfig, filters) {
  const queryClient = getSharedQueryClient();
  const queryKey = generateQueryKey(methodConfig, filters == null ? void 0 : filters.request);
  const candidates = queryClient.getQueryCache().findAll({
    exact: false,
    queryKey
  });
  const queryFilter = getQueryFilter(filters != null ? filters : {});
  return candidates.filter(query => queryFilter(query)).map(query => toCachedQuery(query));
}
//# sourceMappingURL=cacheOperations.js.map